import React from 'react';
import { motion } from 'framer-motion';
import { FaTruck, FaPhone, FaGlobe, FaClock, FaSun, FaUtensils } from 'react-icons/fa';

export default function LocationInfo() {
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      className="space-y-8"
    >
      {/* No Reservations Section */}
      <motion.div
        whileHover={{ scale: 1.02 }}
        className="group bg-gradient-to-br from-white/90 to-white/80 backdrop-blur-sm rounded-2xl p-8 
                   shadow-xl relative overflow-hidden border border-red-100"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-red-500/5 via-transparent to-amber-500/5 
                      opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        
        <FaUtensils className="w-8 h-8 text-red-600 mb-4" />
        <h3 className="text-2xl font-bold text-gray-900 mb-3 retro-text">
          Bestil bord? Pjat med det!
        </h3>
        <p className="text-gray-600 relative z-10">
          Vi har altid plads ved vores foderbræt, så drop bare ind, når sulten melder sig. 
          Er vejret lækkert? Så smækker vi borde og stole ud, så du kan nyde både solen, 
          en iskold Jolly, og en hotter med det hele.
        </p>
      </motion.div>

      {/* Events Section */}
      <motion.div
        whileHover={{ scale: 1.02 }}
        className="group bg-gradient-to-br from-white/90 to-white/80 backdrop-blur-sm rounded-2xl p-8 
                   shadow-xl relative overflow-hidden border border-red-100"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-red-500/5 via-transparent to-amber-500/5 
                      opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        
        <FaTruck className="w-8 h-8 text-red-600 mb-4" />
        <h3 className="text-2xl font-bold text-gray-900 mb-3 retro-text">
          Events & Arrangementer
        </h3>
        <p className="text-gray-600 mb-6 relative z-10">
          Vil du være helten bag det næste store event? Vi svinger gerne forbi med vores 
          foodtruck og fylder maverne med alt fra pølser og frikadeller til flæskestegssandwich 
          eller lige præcis det, du drømmer om.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 relative z-10">
          <motion.a
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            href="tel:28195077"
            className="inline-flex items-center px-6 py-3 bg-red-600 text-white rounded-full
                     shadow-xl shadow-red-600/20 hover:bg-red-700 transition-colors"
          >
            <FaPhone className="mr-2" />
            <span>Ring til Brian: 28 19 50 77</span>
          </motion.a>
          <motion.a
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            href="https://bchudlejning.dk"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 bg-white text-red-600 rounded-full
                     border-2 border-red-600/30 shadow-xl shadow-red-600/10 
                     hover:bg-red-50 transition-colors"
          >
            <FaGlobe className="mr-2" />
            <span>BCHudlejning.dk</span>
          </motion.a>
        </div>
      </motion.div>

      {/* Opening Hours */}
      <motion.div
        whileHover={{ scale: 1.02 }}
        className="group bg-gradient-to-br from-white/90 to-white/80 backdrop-blur-sm rounded-2xl p-8 
                   shadow-xl relative overflow-hidden border border-red-100"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-red-500/5 via-transparent to-amber-500/5 
                      opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        
        <FaClock className="w-8 h-8 text-red-600 mb-4" />
        <h3 className="text-2xl font-bold text-gray-900 mb-3 retro-text">
          Åbningstider
        </h3>
        <div className="space-y-2 text-gray-600 relative z-10">
          <p className="flex items-center">
            <FaSun className="w-4 h-4 mr-2 text-amber-500" />
            <span>Mandag – Fredag: 10:30 – 17:00</span>
          </p>
          <p className="flex items-center">
            <FaSun className="w-4 h-4 mr-2 text-amber-500" />
            <span>Lørdag: Lukket</span>
          </p>
          <p className="flex items-center">
            <FaSun className="w-4 h-4 mr-2 text-amber-500" />
            <span>Søndag & helligdage: Lukket</span>
          </p>
        </div>
        <p className="mt-6 text-lg font-medium text-red-600 relative z-10">
          Vi ses til en hotter og et smil! 🌭✨
        </p>
      </motion.div>
    </motion.div>
  );
}